import React, { useState } from "react";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { FaMapMarkerAlt, FaClock } from "react-icons/fa";
import CustomButton from "../common/CustomButton";

const ExperienceCard = ({
  id,
  img,
  location,
  title,
  price,
  time,
  tag = "Experience",
  mapview = false,
}) => {
  const [favorite, setFavorite] = useState(false);

  const toggleFavorite = () => {
    setFavorite((prev) => !prev);
  };

  const completeLocation = `${location?.city}, ${location?.country}`;

  return (
    <div
      className={`${
        mapview ? "w-full" : ""
      } cursor-pointer single-prod border border-borderGray rounded-2xl bg-surfaceBg overflow-visible ${
        mapview ? "some-mapview-class" : ""
      }`}
    >
      {/* IMAGE + TAG + HEART */}
      <div className="relative">
        <img
          src={img}
          alt="product banner"
          loading="lazy"
          className="rounded-t-xl w-full object-cover h-[180px] md:h-[200px] lg:h-[220px] xl:h-[240px] 2xl:h-[260px]"
        />

        {/* Tag */}

        {!mapview && (
          <span className="absolute top-3 left-3 bg-white/70 backdrop-blur-md text-gray-700 text-xs font-medium px-3 py-1 rounded-full shadow-sm">
            {tag}
          </span>
        )}

        {/* Heart Button */}

        {!mapview && (
          <button
            onClick={toggleFavorite}
            className="absolute top-3 right-3 bg-white/70 backdrop-blur-md p-2 rounded-full shadow-md hover:scale-110 transition-all"
          >
            {favorite ? (
              <AiFillHeart className="text-red-500 text-xl" />
            ) : (
              <AiOutlineHeart className="text-gray-700 text-xl" />
            )}
          </button>
        )}
      </div>

      {/* CONTENT */}
      <div className="prod-content p-2 md:p-3 lg:p-4">
        <p className="text-primaryText flex items-center gap-1 text-[12px] md:text-[12px] lg:text-[12px] xl:text-[13px] font-[500] mb-1">
          <FaMapMarkerAlt />
          {completeLocation}
        </p>

        <div className="min-h-[30px] pt-1 md:pt-2">
          <h3 className="text-[14px] md:text-[18px] lg:text-[16px] xl:text-[18px] font-[600] leading-[22px] line-clamp-2">
            {title}
          </h3>
        </div>
        {!mapview && (
          <div className="ml-0.5">
            <CustomButton
              variant="primary"
              fullWidth={false}
              className="mt-3 md:mt-4"
            >
              Book Now
            </CustomButton>
          </div>
        )}
        <div className="flex justify-between items-center pt-2 md:pt-3 ml-1">
          <p className="text-[16px] md:text-[20px] lg:text-[18px] xl:text-[20px]">
            ${price}{" "}
            <span className="text-[#737373] text-[12px] md:text-[14px] font-normal">
              / person
            </span>
          </p>
          <p className="text-[#242424] text-[13px] md:text-[14px] flex items-center gap-2">
            <FaClock />
            {time}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExperienceCard;
